import competition from '@/api/schema/competition'
import moment from 'moment'
import { schema } from 'normalizr'
export default new schema.Entity(
    'classifications',
    {
        competition,
    },
    {
        processStrategy: classification => ({
            // Meta.
            _type: 'classification',
            // Fields.
            ...classification,
            // Cast types.
            startTime: classification.startTime
                ? moment(classification.startTime)
                : null,
            endTime: classification.endTime
                ? moment(classification.endTime)
                : null,
        }),
    }
)
